var map = {
	"./android.png": 6593,
	"./angular.png": 4747,
	"./aws.png": 3921,
	"./aws1.png": 9950,
	"./bootstrap.png": 5070,
	"./css3.png": 270,
	"./default.png": 3832,
	"./django.png": 4628,
	"./dotnet.png": 6102,
	"./express js.png": 5925,
	"./firebase.png": 647,
	"./flutter.png": 1810,
	"./graphql.png": 5829,
	"./html5.png": 5745,
	"./ios.png": 9544,
	"./javascript.png": 3294,
	"./jquery.png": 2520,
	"./laravel.png": 7973,
	"./mongodb.png": 2581,
	"./mysql.png": 8441,
	"./node js.png": 9253,
	"./php.png": 5379,
	"./postgresql.png": 6853,
	"./python.png": 1086,
	"./react js.png": 8238,
	"./react native.png": 7414,
	"./ruby on rails.png": 4651,
	"./ruby.png": 9816,
	"./shopify.png": 475,
	"./sqlite.png": 7110,
	"./sqlserver.png": 3261,
	"./tailwind.png": 5167,
	"./wordpress.png": 3164,
	"./xamarin.png": 2728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3239;